<template lang="html">
  <v-flex pa-1>
    <!-- <v-col class="px-0" v-if="section.textPre" v-html="_templateLiteralString(section.textPre)"></v-col> -->
    <v-col
      v-if="section.textPre"
      class="px-0"
      v-html="section.textPre"
    />

    <!-- <div class="no-print">
      <v-row class="">
        <v-col>
          <SiInputNumber
            :value="splitPercent"
            @input="handlePercentChange"
            label="Split percentage"
            decimals="5"
            incriment="1"
            prefix="%"
            :max="100"
            :min="0"
            shaped outlined/>
        </v-col>
        <v-col>
          <SiInputCurrency
            :value="splitBaseAmount"
            @input="handleBaseChange"
            label="Split base amount"
            shaped outlined/>
        </v-col>
      </v-row>
      <v-col class="pa-0 mb-4">
        <v-slider
          v-model="splitSlider"
          ref="slider"
          label="Split"
          class="si-split-percentage-slider"
          thumb-label
          :min="0"
          :max="100"
        >
         <template v-slot:thumb-label="{ value }">
            {{value}}%
          </template>
        </v-slider>
      </v-col>
    </div>

    <div class="only-print">
      <v-row class="">
        <v-col cols="6">
          Split percentage
          <div class="text-h5">{{splitPercent}}%</div>
        </v-col>
         <v-col cols="6">
          Split base amount
          <div class="text-h5">{{_$(splitBaseAmount, 0)}}</div>
        </v-col>
      </v-row>
    </div>   -->

    <div v-if="show">
      <flv-splitting-growth 
        v-if="report_data.interest_type === 'growth'" 
        :data="report_data" 
        :tables="tables"
        @percent-change="handlePercentChange"
      />
      <!-- :splitPercent="Number(splitPercent)" -->
      <flv-splitting-payment 
        v-if="report_data.interest_type === 'payment'" 
        :data="report_data"
        @percent-change="handlePercentChange"
      />
      <!-- :splitPercent="Number(splitPercent)" -->
    </div>
    <v-skeleton-loader
      v-else
      type="image"
    />

    <v-alert 
      dense 
      type="warning" 
      class="only-print mt-6 body-2"  
      outlined
      border="left" 
    >
      Values in this section of report are dynamic and were set by the user at the time of printing.
    </v-alert>

    <!-- <v-col class="px-0" v-if="section.textPost" v-html="_templateLiteralString(section.textPost)"></v-col> -->
    <v-col
      v-if="section.textPost"
      class="px-0"
      v-html="section.textPost"
    />
  </v-flex>
</template>

<script>
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    },
    section: Object,
  },
  data () {
    return {
      show: false,
      // splitSlider: 0,
      // updateTimeout: null,
      // internalChange: false,
      // splitPercent: 0,
      // splitBaseAmount: 0,
    }
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    report_data () {
      return this.report.report_data || {}
    },
    tables () {
      return this.report.tables || {}
    },
  },
  mounted () {
    // setTimeout(() => {
    //   let thumb = this.$refs.slider.$el.getElementsByClassName('v-slider__thumb-container')[0]
    //   if (thumb) {
    //     thumb.focus()
    //     setTimeout(() => thumb.blur(), 800)
    //   }
    // }, 1500)
    setTimeout(() => this.show = true, 100) // do this to delay load. Makes rendering report smoother as this contains so many graphs
  },
  methods: {
    handlePercentChange (percent) {
      this.setValues({ percent })
    },
  //   handleBaseChange (amount) {
  //     this.setValues({ amount })
  //   },
  //   setValues ({percent, amount}) {
  //     this.internalChange = true
  //     if (percent !== undefined) {
  //       amount = ((Math.floor(this.report_data.flv / 100) * (percent / 100)) * 100).toFixed(0)
  //     } else if (amount !== undefined) {
  //       percent = Math.floor(amount / 100) / Math.floor(this.report_data.flv / 100) * 100
  //     } else {
  //       return 
  //     }

  //     if (isNaN(amount)) amount = 0

  //     this.splitSlider = percent
  //     this.splitPercent = percent
  //     this.splitBaseAmount = amount

  //     this.$nextTick(() => {this.internalChange = false})
  //   }
  // },
  // watch: {
  //   splitSlider (percent) {
  //     if (this.splitPercent !== percent && !this.internalChange) {
  //       if (this.updateTimeout) clearTimeout(this.updateTimeout)
  //       this.updateTimeout = setTimeout(() => {
  //         this.setValues({ percent })
  //       }, 5)
  //     }
  //   },
  }
}
</script>

<style lang="css">
  .v-slider__thumb-container:focus .v-slider__thumb:before {
    transform: scale(1);
  }
  .si-split-percentage-slider label{
    width: 70px;
  }
</style>
